export default __webpack_public_path__ + "statics/SaunaPro-Bold.svg";